<main class="recover-shell">
  <div class="recover-art" aria-hidden="true">
    <div class="recover-area-shape"></div>
    <svg
      class="recover-mountain-line"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <path
        class="recover-mountain-reference"
        pathLength="1"
        d="M0 94 L100 58"
      ></path>
      <path
        class="recover-mountain-primary"
        pathLength="1"
        d="M0 82 L5 77 L10 74 L15 76 L20 68 L25 61 L30 64 L35 57 L40 48 L45 51 L50 43 L55 33 L60 37 L65 30 L70 21 L75 25 L80 16 L85 6 L90 10 L95 3 L100 0"
      ></path>
    </svg>

    <div class="analytics-card analytics-card-ring recover-float-one">
      <div class="metric-ring"><span></span></div>
      <div class="metric-lines"><i></i><i></i><i></i></div>
    </div>

    <div class="analytics-card analytics-card-bars recover-float-two">
      <div class="bar bar-one"></div>
      <div class="bar bar-two"></div>
      <div class="bar bar-three"></div>
      <div class="bar bar-four"></div>
      <div class="bar bar-five"></div>
      <div class="bar bar-highlight"></div>
      <span class="bar-arrow"></span>
    </div>

    <div class="analytics-card analytics-card-chart recover-float-three">
      <span class="currency-tile">$</span>
      <svg class="mini-trend" viewBox="0 0 132 54" aria-hidden="true">
        <polyline
          pathLength="1"
          points="0,50 24,30 46,40 72,12 95,28 132,2"
        ></polyline>
      </svg>
      <div class="metric-lines"><i></i><i></i></div>
    </div>

    <div class="analytics-card analytics-card-progress recover-float-four">
      <i></i><i></i><i></i>
    </div>

    <span class="currency-tile currency-one recover-float-five">$</span>
    <span class="currency-tile currency-two recover-float-six">$</span>
  </div>

  <div class="recover-brand">
    <img src="assets/logo-broadfactor-white-letter.png" alt="broadfactor" />
  </div>

  <section
    class="form-page"
    aria-labelledby="recover-title"
    *ngIf="!successResponse"
  >
    <div class="recover-icon" aria-hidden="true">
      <mat-icon>vpn_key</mat-icon>
    </div>

    <h1 id="recover-title">Recuperar senha</h1>
    <p class="recover-description">
      Informe o e-mail da sua conta e enviaremos um link para você criar uma
      nova senha.
    </p>

    <div class="alert alert-danger" role="alert" *ngIf="errorResponse">
      {{ errorMessage }}
    </div>

    <mat-form-field appearance="outline">
      <mat-label>E-mail</mat-label>
      <input
        #email="ngModel"
        matInput
        [(ngModel)]="mail"
        type="email"
        placeholder="voce@empresa.com.br"
        required
        email
      />
    </mat-form-field>

    <button
      class="recover-submit"
      mat-flat-button
      type="button"
      *ngIf="!loading"
      [disabled]="!mail || email.invalid"
      (click)="sendMail()"
    >
      Enviar link de recuperação
    </button>

    <button
      class="recover-submit"
      mat-flat-button
      type="button"
      disabled
      *ngIf="loading"
    >
      Enviando
      <mat-spinner class="d-inline-block ml-2" [diameter]="20"></mat-spinner>
    </button>

    <a class="recover-back" mat-stroked-button [routerLink]="['/login']">
      <mat-icon aria-hidden="true">arrow_back</mat-icon>
      Voltar para o login
    </a>
  </section>

  <section
    class="form-page confirmation-page"
    aria-labelledby="confirmation-title"
    *ngIf="successResponse"
  >
    <div class="recover-icon confirmation-icon" aria-hidden="true">
      <mat-icon>mail_outline</mat-icon>
    </div>

    <h1 id="confirmation-title">Confira seu e-mail</h1>
    <p class="confirmation-description">
      Se existir uma conta para <strong>{{ mail }}</strong
      >, o link chega em instantes. Olhe também o spam. O link vale por 30
      minutos.
    </p>

    <a class="confirmation-submit" mat-flat-button [routerLink]="['/login']">
      Voltar para o login
    </a>
  </section>
</main>
